import React from 'react'
import { authContext } from '../Login/AuthContext';
import "../conf.js"
import {PlotLine3var, PlotLine6var, PlotLines, PlotBarVars, getColData, getColDataMult} from "./config.js"
import AreasTable from './Areas/AreasTable'
import AsyncCSV from '../config/ExportCSV'

//export default class VectorLayersExample extends Component {
export default class Frequentation extends React.Component {
  constructor (){
    super();
    this.state = {
      headerFrequentation : [
          {label:"year", key:"year"},
          {label:"month", key:"month"},
          {label:"nb", key: "nb"},
          {label:"night", key:"night"},
          {label:"estimatedOverNights", key:"estimatedOverNights"},
          {label:"Motif_Business", key:"PerCentBusinnes"},
          {label:"Motif_Leisure", key:"PerCentLeisure"},
          {label:"Motif_Other", key:"PerCentOther"},
          {label:"CS_Family", key:"PerCentFamily"},
          {label:"CS_Solo", key:"PerCentsolo"},
          {label:"CS_Young", key:"PerCentYoung"},
          {label:"CS_Group", key:"PerCentGroup"},
          {label:"CS_Mature", key:"PerCentMature"},
          {label:"CS_OldChildren", key:"PerCentOldChildren"},
          {label:"fr_checkin", key:"fr"},
          {label:"be_checkin", key:"be"},
          {label:"nl_checkin", key:"nl"},
          {label:"es_checkin", key:"es"},
          {label:"gb_checkin", key:"gb"},
          {label:"de_checkin", key:"de"},
          {label:"ch_checkin", key:"ch"},
          {label:"it_checkin", key:"it"},
          {label:"pt_checkin", key:"pt"},
          {label:"ru_checkin", key:"ru"},
          {label:"fr_overnights", key:"fr_overnights"},
          {label:"be_overnights", key:"be_overnights"},
          {label:"nl_overnights", key:"nl_overnights"},
          {label:"es_overnights", key:"es_overnights"},
          {label:"gb_overnights", key:"gb_overnights"},
          {label:"de_overnights", key:"de_overnights"},
          {label:"ch_overnights", key:"ch_overnights"},
          {label:"it_overnights", key:"it_overnights"},
          {label:"pt_overnights", key:"pt_overnights"},
          {label:"ru_overnights", key:"ru_overnights"},
          {label:"fr_Motif_Business", key:"fr_PerCentBusinnes"},
          {label:"be_Motif_Business", key:"be_PerCentBusinnes"},
          {label:"nl_Motif_Business", key:"nl_PerCentBusinnes"},
          {label:"es_Motif_Business", key:"es_PerCentBusinnes"},
          {label:"gb_Motif_Business", key:"gb_PerCentBusinnes"},
          {label:"de_Motif_Business", key:"de_PerCentBusinnes"},
          {label:"ch_Motif_Business", key:"ch_PerCentBusinnes"},
          {label:"it_Motif_Business", key:"it_PerCentBusinnes"},
          {label:"pt_Motif_Business", key:"pt_PerCentBusinnes"},
          {label:"ru_Motif_Business", key:"ru_PerCentBusinnes"},
          {label:"fr_Motif_Leisure", key:"fr_PerCentLeisure"},
          {label:"be_Motif_Leisure", key:"be_PerCentLeisure"},
          {label:"nl_Motif_Leisure", key:"nl_PerCentLeisure"},
          {label:"es_Motif_Leisure", key:"es_PerCentLeisure"},
          {label:"gb_Motif_Leisure", key:"gb_PerCentLeisure"},
          {label:"de_Motif_Leisure", key:"de_PerCentLeisure"},
          {label:"ch_Motif_Leisure", key:"ch_PerCentLeisure"},
          {label:"it_Motif_Leisure", key:"it_PerCentLeisure"},
          {label:"pt_Motif_Leisure", key:"pt_PerCentLeisure"},
          {label:"ru_Motif_Leisure", key:"ru_PerCentLeisure"},
          {label:"fr_Motif_Other", key:"fr_PerCentOther"},
          {label:"be_Motif_Other", key:"be_PerCentOther"},
          {label:"nl_Motif_Other", key:"nl_PerCentOther"},
          {label:"es_Motif_Other", key:"es_PerCentOther"},
          {label:"gb_Motif_Other", key:"gb_PerCentOther"},
          {label:"de_Motif_Other", key:"de_PerCentOther"},
          {label:"ch_Motif_Other", key:"ch_PerCentOther"},
          {label:"it_Motif_Other", key:"it_PerCentOther"},
          {label:"pt_Motif_Other", key:"pt_PerCentOther"},
          {label:"ru_Motif_Other", key:"ru_PerCentOther"},
          {label:"fr_Context_Family", key:"fr_PerCentFamily"},
          {label:"be_Context_Family", key:"be_PerCentFamily"},
          {label:"nl_Context_Family", key:"nl_PerCentFamily"},
          {label:"es_Context_Family", key:"es_PerCentFamily"},
          {label:"gb_Context_Family", key:"gb_PerCentFamily"},
          {label:"de_Context_Family", key:"de_PerCentFamily"},
          {label:"ch_Context_Family", key:"ch_PerCentFamily"},
          {label:"it_Context_Family", key:"it_PerCentFamily"},
          {label:"pt_Context_Family", key:"pt_PerCentFamily"},
          {label:"ru_Context_Family", key:"ru_PerCentFamily"},
          {label:"fr_Context_solo", key:"fr_PerCentsolo"},
          {label:"be_Context_solo", key:"be_PerCentsolo"},
          {label:"nl_Context_solo", key:"nl_PerCentsolo"},
          {label:"es_Context_solo", key:"es_PerCentsolo"},
          {label:"gb_Context_solo", key:"gb_PerCentsolo"},
          {label:"de_Context_solo", key:"de_PerCentsolo"},
          {label:"ch_Context_solo", key:"ch_PerCentsolo"},
          {label:"it_Context_solo", key:"it_PerCentsolo"},
          {label:"pt_Context_solo", key:"pt_PerCentsolo"},
          {label:"ru_Context_solo", key:"ru_PerCentsolo"},
          {label:"fr_Context_Young", key:"fr_PerCentYoung"},
          {label:"be_Context_Young", key:"be_PerCentYoung"},
          {label:"nl_Context_Young", key:"nl_PerCentYoung"},
          {label:"es_Context_Young", key:"es_PerCentYoung"},
          {label:"gb_Context_Young", key:"gb_PerCentYoung"},
          {label:"de_Context_Young", key:"de_PerCentYoung"},
          {label:"ch_Context_Young", key:"ch_PerCentYoung"},
          {label:"it_Context_Young", key:"it_PerCentYoung"},
          {label:"pt_Context_Young", key:"pt_PerCentYoung"},
          {label:"ru_Context_Young", key:"ru_PerCentYoung"},
          {label:"fr_Context_Group", key:"fr_PerCentGroup"},
          {label:"be_Context_Group", key:"be_PerCentGroup"},
          {label:"nl_Context_Group", key:"nl_PerCentGroup"},
          {label:"es_Context_Group", key:"es_PerCentGroup"},
          {label:"gb_Context_Group", key:"gb_PerCentGroup"},
          {label:"de_Context_Group", key:"de_PerCentGroup"},
          {label:"ch_Context_Group", key:"ch_PerCentGroup"},
          {label:"it_Context_Group", key:"it_PerCentGroup"},
          {label:"pt_Context_Group", key:"pt_PerCentGroup"},
          {label:"ru_Context_Group", key:"ru_PerCentGroup"}
        ]
    }
  }
  state = {
    headerFrequentation : [],
  }
  static contextType = authContext;

  componentDidMount = () => {
      if(this.context.auth.data && this.context.auth.data.token && this.context.auth.data.zone){
        this.topCountries(this.context.auth.data.token, this.context.auth.data.zone.shapes);
      }
  }

  topCountries = (token, shapes) => {
      fetch("https://mel.dvrc.fr/api/Booking_Origin_bygadm36.php?id="+shapes+"&limit=10&token="+token)
          .then(res => res.json())
          .then( (data) => {
            var topCountries = [];
            for(var i=0; i<data.length;i++){
              topCountries.push (data[i].author_countrycode)
            }
            for(var i=0; i<global.years.length; i++){
              this.updateStat (token, shapes, topCountries, global.years[i]);
            }
            //this.updateStats(token, shapes, topCountries)
          });
    }

  async updateStat (token, shapes, topCountries, year){
      //console.log('https://mel.dvrc.fr/api/GetBookingDataYearByShapeGID36.php?shape_gid=' + shapes + "&year="+year+"&topCountries="+topCountries+"&token="+token)
    const[data] = await Promise.all([
        fetch('https://mel.dvrc.fr/api/GetBookingDataYearByShapeGID36.php?shape_gid=' + shapes + "&year="+year+"&topCountries="+topCountries+"&token="+token).then(res => res.json())
      ]);
      this.toCSV (data, year)
      //Charts de fréquentation
      var labelsYears=global.years;

      PlotBarVars('myChart',year,getColData(data,0,1),'Réservation B par mois', year)
      PlotBarVars('myChart2',year,getColData(data,0,11),'Nombre moyen de nuits', year)
      PlotBarVars('myChart3',year,getColData(data,0,22),'Nombre moyen de nuitées estimées',year)

      //Charts de fréquentation par pays

      for(var i = 0;i<10;i++){
        PlotLines('Pays'+i+'FreqRep',year, getColData(data,0,i+12),topCountries[i]+' - variation annuelle des proportions de réservations B',year,global.years.length,true);
        PlotBarVars('Pays'+i+'FreqAbs',year,getColDataMult(data,0,1,i+12),topCountries[i]+' - variation annuelle des réservations B', year)
        PlotBarVars('Pays'+i+'Overnights',year,getColData(data,0,i+23),topCountries[i]+' - variation annuelle des nuitées estimées', year)
      }


      //Chart by type of travel
      //var labelsTypeVoyage= ['business','leisure','other'];
      var labelsTypeVoyage= ['Professionnel','Loisir','Autre'];
      PlotLines('Type'+year,year,getColData(data,0,2),year,labelsTypeVoyage[0],labelsTypeVoyage.length);
      PlotLines('Type'+year,year,getColData(data,0,3),year,labelsTypeVoyage[1],labelsTypeVoyage.length);
      PlotLines('Type'+year,year,getColData(data,0,4),year,labelsTypeVoyage[2],labelsTypeVoyage.length);

      for(i = 0;i<10;i++){
        PlotLines('MotifCountry'+year+'_'+i,year, getColData(data,0,i+33),topCountries[i]+' - Motif de voyage',labelsTypeVoyage[0],labelsTypeVoyage.length,true);
        PlotLines('MotifCountry'+year+'_'+i,year, getColData(data,0,i+43),topCountries[i]+' - Motif de voyage',labelsTypeVoyage[1],labelsTypeVoyage.length,true);
        PlotLines('MotifCountry'+year+'_'+i,year, getColData(data,0,i+53),topCountries[i]+' - Motif de voyage',labelsTypeVoyage[2],labelsTypeVoyage.length,true);
      }

      //Chart by type of author
      PlotLines('TypeAuthor'+year,year,getColData(data,0,5), year, 'family with young children',labelsTypeVoyage.length-2,true);
      PlotLines('TypeAuthor'+year,year,getColData(data,0,6), year, 'solo traveller',labelsTypeVoyage.length-2,true);
      PlotLines('TypeAuthor'+year,year,getColData(data,0,7), year, 'young couple',labelsTypeVoyage.length-2,true);
      PlotLines('TypeAuthor'+year,year,getColData(data,0,8), year, 'group of friends',labelsTypeVoyage.length-2,true);
      //PlotLines('TypeAuthor'+year,year,getColData(data,0,9),year, 'mature couple',global.years.length,true);
      //PlotLines('TypeAuthor'+year,year,getColData(data,0,10),year, 'family with older children',global.years.length,true);

      PlotBarVars('TypeAuthorFamilyyoung',year,getColDataMult(data,0,1,5),'Famille avec jeunes enfants - Réservations B',year);
      PlotBarVars('TypeAuthorSolo',year,getColDataMult(data,0,1,6),'Voyageur seul - Réservations B',year);
      PlotBarVars('TypeAuthorCouple',year,getColDataMult(data,0,1,7),'Jeunes couples - Réservations B',year);
      PlotBarVars('TypeAuthorFriends',year,getColDataMult(data,0,1,8),'Groupes d\'amis - Réservations B',year);

      for(i = 0;i<10;i++){
        PlotLines('CSCountry'+year+'_'+i,year,getColData(data,0,i+63),topCountries[i]+' - '+year,'family with young children',global.years.length-2,true);
        PlotLines('CSCountry'+year+'_'+i,year,getColData(data,0,i+73),topCountries[i]+' - '+year,'solo traveller',global.years.length-2,true);
        PlotLines('CSCountry'+year+'_'+i,year,getColData(data,0,i+83),topCountries[i]+' - '+year,'young couple',global.years.length-2,true);
        PlotLines('CSCountry'+year+'_'+i,year,getColData(data,0,i+93),topCountries[i]+' - '+year,'group of friends',global.years.length-2,true);
      }
  }
/*
  async updateStats (token, shapes, topCountries) {
        const[data2018, data2019, data2020] = await Promise.all([
            fetch('https://mel.dvrc.fr/api/GetBookingDataYearByShapeGID36.php?shape_gid=' + shapes + "&year=2018&topCountries="+topCountries+"&token="+token).then(res => res.json()),
            fetch('https://mel.dvrc.fr/api/GetBookingDataYearByShapeGID36.php?shape_gid=' + shapes + "&year=2019&topCountries="+topCountries+"&token="+token).then(res => res.json()),
            fetch('https://mel.dvrc.fr/api/GetBookingDataYearByShapeGID36.php?shape_gid=' + shapes + "&year=2020&topCountries="+topCountries+"&token="+token).then(res => res.json()),
          ]);
          var data18=data2018;
          var data19=data2019;
          var data20=data2020;

          this.toCSV (data2018, 2018)
          this.toCSV (data2019, 2019)
          this.toCSV (data2020, 2020)
          //Charts de fréquentation
          var labelsYears=['2018','2019','2020'];

          //PlotBar2var('myChart',getColData(data19,0,1),getColData(data20,0,1),'Check-in by month');
          //PlotBar2var('myChart2',getColData(data19,0,11),getColData(data20,0,11),'Average number of night');

          PlotBar3var('myChart',getColData(data18,0,1),getColData(data19,0,1),getColData(data20,0,1),'Réservation B par mois');
          PlotBar3var('myChart2',getColData(data18,0,11),getColData(data19,0,11),getColData(data20,0,11),'Nombre moyen de nuits',labelsYears);
          PlotBar3var('myChart3',getColData(data18,0,22),getColData(data19,0,22),getColData(data20,0,22),'Nombre moyen de nuitées estimées',labelsYears);

          //Charts de fréquentation par pays

          for(var i = 0;i<10;i++){
            PlotLine3var('Pays'+i+'FreqRep',getColData(data18,0,i+12),getColData(data19,0,i+12),getColData(data20,0,i+12),topCountries[i]+' - variation annuelle des proportions de réservations B',labelsYears,true);
            PlotBar3var('Pays'+i+'FreqAbs',getColDataMult(data18,0,1,i+12),getColDataMult(data19,0,1,i+12),getColDataMult(data20,0,1,i+12),topCountries[i]+' - variation annuelle des réservations B');
            PlotBar3var('Pays'+i+'Overnights',getColData(data18,0,i+23),getColData(data19,0,i+23),getColData(data20,0,i+23),topCountries[i]+' - variation annuelle des nuitées estimées');
          }


          //Chart by type of travel
          //var labelsTypeVoyage= ['business','leisure','other'];
          var labelsTypeVoyage= ['Professionnel','Loisir','Autre'];
          PlotLine3var('Type2018',getColData(data18,0,2),getColData(data18,0,3),getColData(data18,0,4),'2018',labelsTypeVoyage,true);
          PlotLine3var('Type2019',getColData(data19,0,2),getColData(data19,0,3),getColData(data19,0,4),'2019',labelsTypeVoyage,true);
          PlotLine3var('Type2020',getColData(data20,0,2),getColData(data20,0,3),getColData(data20,0,4),'2020',labelsTypeVoyage,true);

          PlotLine3var('MotifCountry2018',getColData(data18,0,34),getColData(data18,0,35),getColData(data18,0,36),getColData(data18,0,37),getColData(data18,0,38),getColData(data18,0,39),getColData(data18,0,40),getColData(data18,0,41),getColData(data18,0,42),getColData(data18,0,43),'2018',labelsTypeVoyage,true);

          for(i = 0;i<10;i++){
            PlotLine3var('MotifCountry2018_'+i,getColData(data18,0,i+33),getColData(data18,0,i+43),getColData(data18,0,i+53),topCountries[i]+' - Motif de voyage',labelsTypeVoyage,true);
            PlotLine3var('MotifCountry2019_'+i,getColData(data19,0,i+33),getColData(data19,0,i+43),getColData(data19,0,i+53),topCountries[i]+' - Motif de voyage',labelsTypeVoyage,true);
            PlotLine3var('MotifCountry2020_'+i,getColData(data20,0,i+33),getColData(data20,0,i+43),getColData(data20,0,i+53),topCountries[i]+' - Motif de voyage',labelsTypeVoyage,true);
          }


          //Chart by type of author
          PlotLine6var('TypeAuthor2018',getColData(data18,0,5),getColData(data18,0,6),getColData(data18,0,7),getColData(data18,0,8),getColData(data18,0,9),getColData(data18,0,10),'2018',true);
          PlotLine6var('TypeAuthor2019',getColData(data19,0,5),getColData(data19,0,6),getColData(data19,0,7),getColData(data19,0,8),getColData(data19,0,9),getColData(data19,0,10),'2019',true);
          PlotLine6var('TypeAuthor2020',getColData(data20,0,5),getColData(data20,0,6),getColData(data20,0,7),getColData(data20,0,8),getColData(data20,0,9),getColData(data20,0,10),'2020',true);
          //Chart by type of author
          PlotBar3var('TypeAuthorFamilyyoung',getColDataMult(data18,0,1,5),getColDataMult(data19,0,1,5),getColDataMult(data20,0,1,5),'Famille avec jeunes enfants - Réservations B',labelsYears,true);
          PlotBar3var('TypeAuthorSolo',       getColDataMult(data18,0,1,6),getColDataMult(data19,0,1,6),getColDataMult(data20,0,1,6),'Voyageur seul - Réservations B',labelsYears,true);
          PlotBar3var('TypeAuthorCouple',     getColDataMult(data18,0,1,7),getColDataMult(data19,0,1,7),getColDataMult(data20,0,1,7),'Jeunes couples - Réservations B',labelsYears,true);
          PlotBar3var('TypeAuthorFriends',    getColDataMult(data18,0,1,8),getColDataMult(data19,0,1,8),getColDataMult(data20,0,1,8),'Groupes d\'amis - Réservations B',labelsYears,true);

          for(i = 0;i<10;i++){
            PlotLine6var('CSCountry2018_'+i,getColData(data18,0,i+63),getColData(data18,0,i+73),getColData(data18,0,i+83),getColData(data18,0,i+93),0,0,topCountries[i]+' - 2018',true);
            PlotLine6var('CSCountry2019_'+i,getColData(data19,0,i+63),getColData(data19,0,i+73),getColData(data19,0,i+83),getColData(data19,0,i+93),0,0,topCountries[i]+' - 2019',true);
            PlotLine6var('CSCountry2020_'+i,getColData(data20,0,i+63),getColData(data20,0,i+73),getColData(data20,0,i+83),getColData(data20,0,i+93),0,0,topCountries[i]+' - 2020',true);
          }
    }
*/

    toCSV = (data, year) => {
      for(var j=0;j<data.length;j++){
        var d = {};
        d.year = year;
        var nb = parseFloat(data[j].nb);
        for (var key in data[j]){
          var value = parseFloat(data[j][key]);
          if(value < 1 || key === "night" || key === "estimatedOverNights")
            d[key] = Math.round(value*nb);
          else {
            d[key] = value;
          }
        };
        var found = 0;
        for(var i=0; i<this.context.auth.data.dataCSV["Freq"].length;i++){
            if(this.context.auth.data.dataCSV["Freq"][i]["year"] == year && this.context.auth.data.dataCSV["Freq"][i]["month"] == d.month)
                found = 1;
        }
        if(!found)
            this.context.auth.data.dataCSV["Freq"].push(d)
      }
      this.context.setAuthData(this.context.auth.data);
    }

    render = () => {
    return (
        <div className="layout">
            <h1 id="areas">Fréquentations sur Booking</h1>
            <AreasTable/>
            <div className="xl-container">
                <div className="alert alert-primary" role="alert">Frequentation -
                  <AsyncCSV name={this.context.auth.data.zone.name+"_Freq"} header={this.state.headerFrequentation} dataCSV="Freq"/></div>
                <div className="row">
                    <div className="col"><canvas id="myChart" width="33%" height="25%"></canvas></div>
                    <div className="col"><canvas id="myChart2" width="33%" height="25%"></canvas></div>
                    <div className="col"><canvas id="myChart3" width="33%" height="25%"></canvas></div>
                </div>
            </div>

            <div className="xl-container">
                <div className="alert alert-primary" role="alert">Frequentation par pays</div>

                {
                  [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((td, key) => {
                    return (
                      <div className="row" key={"div_pays_"+key}>
                          <div className="col" key={"div_pays_"+key+"b"}>
                              <canvas id={"Pays"+key+"FreqRep"} width="33%" height="25%"></canvas>
                              <button id={"Pays"+key+"FreqRepB"} type="button" className="btn btn-primary btn-sm">Dynamic scale</button>
                          </div>
                          <div className="col"><canvas id={"Pays"+key+"FreqAbs"} width="33%" height="25%"></canvas></div>
                          <div className="col"><canvas id={"Pays"+key+"Overnights"} width="33%" height="25%"></canvas></div>
                      </div>
                    )
                  })
                }
            </div>

            <div className="xl-container">
                <div className="alert alert-primary" role="alert">Fréquentation par motif de voyage</div>
                <div className="row">
                {
                  global.years.map((td, key)=> {
                    return (
                      <div className="col">
                        <center>{td}</center>
                        <canvas id={"Type"+td} width="33%" height="25%"></canvas>
                        <button id={"Type"+td+"B"} type="button" className="btn btn-primary btn-sm">Dynamic scale</button>
                      </div>
                    )
                  })
                }
                </div>
                {
                  [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((td, key) => {
                    return (
                      <div className="row" key={"div_motif_pays_"+key}>
                      {
                        global.years.map((year, td2)=> {
                          return (
                            <div className="col" key={"div_motif_pays_"+year+"_"+key+"b"}>
                              <center>{year}</center>
                              <canvas id={"MotifCountry"+year+"_"+key} width="33%" height="25%"></canvas>
                              <button id={"MotifCountry"+year+"_"+key+"B"} type="button" className="btn btn-primary btn-sm">Dynamic scale</button>
                            </div>
                          )
                        })
                      }
                      </div>
                    )
                  })
                }
            </div>

            <div className="xl-container">
                <div className="alert alert-primary" role="alert">Frequentation par contexte social de visite</div>
                <div className="row">
                {
                  global.years.map((year, td)=> {
                    return (
                    <div className="col">
                        <canvas id={"TypeAuthor"+year} width="33%" height="50%"></canvas>
                        <button id={"TypeAuthor"+year+"B"} type="button" className="btn btn-primary btn-sm">Dynamic scale</button>
                    </div>
                    )
                  })
                }
                </div>
                <div className="row">
                    <div className="col">
                        <canvas id="TypeAuthorFamilyyoung" width="33%" height="25%"></canvas>
                    </div>
                    <div className="col">
                        <canvas id="TypeAuthorSolo" width="33%" height="25%"></canvas>
                    </div>
                    <div className="col">
                        <canvas id="TypeAuthorCouple" width="33%" height="25%"></canvas>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <canvas id="TypeAuthorFriends" width="33%" height="25%"></canvas>
                    </div>
                    <div className="col"></div>
                    <div className="col"></div>
                </div>
                {
                  [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((td, key) => {
                    return (
                      <div className="row" key={"div_CS_pays_"+key}>
                      {
                        global.years.map((year, td)=> {
                          return (
                            <div className="col" key={"div_CS_pays_"+year+"_"+key+"b"}>
                                <canvas id={"CSCountry"+year+"_"+key} width="33%" height="33%"></canvas>
                                <button id={"CSCountry"+year+"_"+key+"B"} type="button" className="btn btn-primary btn-sm">Dynamic scale</button>
                            </div>
                          )
                        })
                      }
                      </div>
                    )
                  })
                }
            </div>

        </div>
    )}
}
